import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Companies visible to all logged-in users (viewer sees limited columns)
const NAV = [
  { to: '/',          label: 'Overview',          icon: '◈', perm: null     },
  { to: '/companies', label: 'Companies',          icon: '⬡', perm: null     },
  { to: '/mgt7a',     label: 'MGT-7A Tracking',   icon: '◉', perm: 'mgt7a' },
  { to: '/gst',       label: 'GST Enrichment',     icon: '◆', perm: 'gst'   },
  { to: '/iec',       label: 'IEC / SIMS',         icon: '▲', perm: 'iec'   },
  { to: '/icegate',   label: 'Import/Export Details',      icon: '▣', perm: 'iec'    },
  { to: '/suppliers', label: 'Suppliers',          icon: '📦', perm: 'dashboard' },
  { to: '/campaigns', label: 'Email Campaigns',     icon: '✉',  perm: 'campaigns' },
];

const ROLE_COLOR = { admin: '#E8C547', analyst: '#44BBA4', viewer: '#2E86AB' };
const ROLE_LABEL = { admin: 'Administrator', analyst: 'Analyst', viewer: 'Viewer' };

export default function Sidebar({ open, onClose }) {
  const { user, logout, can } = useAuth();

  return (
    <>
      {open && <div className="sidebar-backdrop" onClick={onClose} />}
      <aside className={`sidebar ${open ? 'sidebar--open' : ''}`}>
        <div className="sidebar-logo">
          <svg width="36" height="36" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#0F4C81"/>
            <path d="M12 36L24 12L36 36H12Z" fill="none" stroke="#E8C547" strokeWidth="2.5" strokeLinejoin="round"/>
            <circle cx="24" cy="26" r="4" fill="#E8C547"/>
          </svg>
          <div>
            <div className="sidebar-brand">Glazing Genius</div>
            <div className="sidebar-sub">Intelligence Hub</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {NAV.filter(n => !n.perm || can(n.perm)).map(n => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'nav-link--active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-icon">{n.icon}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>

        {/* Role info */}
        <div className="sidebar-role-card">
          <div className="role-dot" style={{ background: ROLE_COLOR[user?.role] || '#888' }} />
          <div>
            <div className="role-name">{ROLE_LABEL[user?.role] || user?.role}</div>
            <div className="role-perms">
              {user?.permissions?.filter(p => p !== 'dashboard').map(p => (
                <span key={p} className="role-perm-tag">{p}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="sidebar-user">
          <div className="user-email">{user?.email}</div>
          <button className="btn-logout" onClick={logout}>Sign Out</button>
        </div>
      </aside>
    </>
  );
}
